import * as monaco from 'monaco-editor';
import Code from '../api/code';
import Logger from './serverLogger.service';

const Moncaco = {
  loaded: false
};

function getDir(model) {
  if (model.dir) return `file://${model.dir}`;
  return 'file://';
}

function getFile(model) {
  return model.gitName || `${model.guid}.js`;
}

function getPath(model) {
  return `${getDir(model)}/${getFile(model)}`;
}

Moncaco.getUri = (model) => {
  const path = getPath(model);
  return monaco.Uri.parse(path);
};

Moncaco.seedEditor = async () => {
  console.log('Loading modules now');
  try {
    const models = await Code.get();
    for (const model of models) {
      console.log(`Creating model for ${getPath(model)}`);
      const uri = Moncaco.getUri(model);
      const existingModel = monaco.editor.getModel(uri);
      if (existingModel) console.warn(`Model already exists for ${getPath(model)}. Skipping...`);
      else monaco.editor.createModel(model.code, 'javascript', uri);
    }

    /**
     * Sync all the models to the worker eagerly.
     * This enables intelliSense for all files without needing an `addExtraLib` call.
     * https://github.com/satya164/monaco-editor-boilerplate/blob/master/src/Editor.js
     * https://microsoft.github.io/monaco-editor/api/interfaces/monaco.languages.typescript.languageservicedefaults.html
     * https://github.com/microsoft/monaco-editor/issues/1310
     */
    // Might not be needed anymore: https://github.com/microsoft/monaco-typescript/commit/14fbd7c2e09b5690f92d89348ea83539683cb206
    // const THIRTY_MINUTES = 30 * 1000 * 60;
    // monaco.languages.typescript.typescriptDefaults.setEagerModelSync(true);
    // monaco.languages.typescript.javascriptDefaults.setEagerModelSync(true);
    // monaco.languages.typescript.typescriptDefaults.setMaximumWorkerIdleTime(THIRTY_MINUTES);
    // monaco.languages.typescript.javascriptDefaults.setMaximumWorkerIdleTime(THIRTY_MINUTES);
  } catch (error) {
    console.error('Unable seed Monaco:');
    console.error(error);
    Logger.error(error);
  }
};

Moncaco.setup = async () => {
  console.log('Initializing Monaco in a web worker');
  if (Moncaco.loaded) {
    console.log('Monaco already seeded with inital seed. Skipping...');
    return;
  }
  Moncaco.loaded = true;
  await Moncaco.seedEditor();
};

export default Moncaco;
